import React from 'react';
import type { FC } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useVersionList } from '../../hooks/versions';
import { WindowsCell } from './Cells/WindowsCell';
import { MacCell } from './Cells/MacCell';
import { LinuxCell } from './Cells/LinuxCell';
import { VersionCell } from './Cells/VersionCell';

export const VersionsTable: FC = () => {
  const versions = useVersionList();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Version</TableCell>
            <TableCell>Windows</TableCell>
            <TableCell>Mac OS</TableCell>
            <TableCell>Linux</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {versions.map(({ version, win, mac, linux }, index) => (
            <TableRow key={version}>
              <VersionCell version={version} isLatest={index === 0} />
              <WindowsCell assets={win} />
              <MacCell assets={mac} />
              <LinuxCell assets={linux} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
